import { useEffect, useRef, useState } from "react";
import Story from "../../sharedComponents/Story/Story";
import stl from "./RadioCard.module.css";
import { useTranslation } from "@i18n";
import Countdown from "react-countdown";
import { trackEvents } from "../../../common/events/events";

const RadioCard = ({
  name,
  checked,
  onChange,
  value,
  className,
  error,
  disabled,
  children,
  story,
  storyText,
  campaignData,
  isFinance,
  setCampaignModal,
  g4Data,
  CardFooter,
}) => {
  const storyRef = useRef();
  const [ShowStory, setShowStory] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`${stl.RadioWrapper} ${checked ? stl.checked : ""} ${
          className ? className : ""
        } ${error ? stl.hasError : ""}  ${disabled && stl.disabled}`}
      >
        <label>
          <input
            type="radio"
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <span className={stl.customRadio}></span>
          {children}
        </label>
        {story && (
          <div className={stl.stryBtn} onClick={() => setShowStory(true)}>
            {storyText}
          </div>
        )}

        {campaignData && (
          <div
            className={stl.campaign}
            style={{ backgroundColor: campaignData?.bg_color }}
          >
            <div>{campaignData?.text}</div>

            <div>
              {campaignData?.counter_timestamp ? (
                <span className={stl.countdownWrapper}>
                  <Countdown
                    date={campaignData?.counter_timestamp * 1000}
                    daysInHours
                    onComplete={() => {}}
                    renderer={({ hours, minutes, seconds, days }) => (
                      <div className={stl.countdown}>
                        {days > 0 ? (
                          <>
                            <strong>{days * 24} </strong>
                          </>
                        ) : (
                          <strong>
                            {hours < 10 ? `0${hours}` : hours + days * 24}
                          </strong>
                        )}
                        :
                        <strong>
                          {minutes < 10 ? `0${minutes}` : minutes}
                        </strong>{" "}
                        :
                        <strong>
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </strong>
                      </div>
                    )}
                  />
                </span>
              ) : null}
              <span
                onClick={() => {
                  trackEvents("marketing_theme_click", {
                    ...g4Data,
                    has_timer: campaignData?.counter_timestamp ? true : false,
                    theme_type: isFinance ? "Finance" : "Cash",
                  });
                  setCampaignModal(isFinance ? "finance" : "cash");
                }}
              >
                {t("اعرف اكثر", {
                  ns: "web_pre_checkout",
                })}
              </span>
            </div>
          </div>
        )}
        {CardFooter && <div>{CardFooter}</div>}
      </div>
      <Story
        ref={storyRef}
        showStoryMode={ShowStory}
        closeStory={() => setShowStory(false)}
        // BGColor={
        //   PaymentTypeFlag == "cash"
        //     ? "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%)"
        //     : ""
        // }
      >
        {story && story}
        {/* {PaymentTypeFlag != "cash"
          ? story_section?.finance_story.data.map((story, idx) => {
              return (
                <div
                  key={"stry" + idx}
                  className="singleStry"
                  // data-color="linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
                >
                  <strong style={{ textalign: "center" }}>
                    {story_section?.finance_story.title}
                  </strong>

                  <img src={story.image} alt="story" />
                </div>
              );
            })
          : story_section?.cash_story?.data.map((story, idx) => {
              return (
                <div
                  key={"stry" + idx}
                  className="singleStry"
                  data-color="linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
                >
                  <strong style={{ textalign: "center" }}>
                    {story_section?.cash_story.title}
                  </strong>

                  <img src={story.image} alt="story" />
                </div>
              );
            })} */}
      </Story>
    </>
  );
};

export default RadioCard;
